import React from 'react';

import { EditSbatGroupInstructorsForm } from 'features/classCreation';
import EditableSection from 'components/EditableSection';
import LectureDetails from '../LectureDetails';
import LectureRequirements from '../LectureRequirements';
import SbatGroupSuperBatchProject from '../SbatGroupSuperBatchProject';

export default function EditSbatGroupLectureForm({
  sbatGroup,
  classTag = null,
}) {
  const sbatProjects =
    sbatGroup?.super_batch_academy_topics[0]?.active_sbat_projects;

  return (
    <>
      <EditableSection
        canEdit
        title="Instructors"
        titleClassName="dark bold"
        className="m-b-s"
      >
        {(editableProps) => (
          <EditSbatGroupInstructorsForm
            {...editableProps}
            sbatGroup={sbatGroup}
          />
        )}
      </EditableSection>
      <LectureDetails sbatGroup={sbatGroup} />
      <LectureRequirements
        sbatGroup={sbatGroup}
        classTag={classTag}
      />
      {sbatProjects?.length > 0 && (
        <EditableSection
          canEdit
          title="Case Study"
          titleClassName="bold dark"
          className="m-b-s"
        >
          {(editableProps) => (
            <>
              <SbatGroupSuperBatchProject
                {...editableProps}
                sbatGroup={sbatGroup}
              />
            </>
          )}
        </EditableSection>
      )}
    </>
  );
}
